import React from 'react';
import { styled } from '@linaria/react';
import { toggle } from 'opticks';
import { Icon } from '@daedalus/atlas/Icon';
import { Text } from '@daedalus/atlas/Text';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
import { Room } from '@daedalus/core/src/room/types/room';
import { RANKED_AMENITIES } from './constants';
type RoomAmenitiesPropsType = {
  room: Pick<Room, 'amenities'>;
  onOpenRoomDetailsOverlay?: () => void;
};
const Header = /*#__PURE__*/styled('div')({
  name: "Header",
  class: "h13s1yur",
  propsAsIs: false
});
const ListItem = /*#__PURE__*/styled('ul')({
  name: "ListItem",
  class: "l182tezm",
  propsAsIs: false
});
const _exp4 = /*#__PURE__*/() => Text;
const RoomInformationItemWrapper = /*#__PURE__*/styled(_exp4())({
  name: "RoomInformationItemWrapper",
  class: "r18j3679",
  propsAsIs: true
});
const _exp5 = /*#__PURE__*/() => Icon;
const StyledIcon = /*#__PURE__*/styled(_exp5())({
  name: "StyledIcon",
  class: "s19t5clh",
  propsAsIs: true
});
const RoomAmenitiesList = ({
  amenities
}: {
  amenities: string[];
}) => <ListItem>
    {amenities.map((amenity, index) => <Text key={index} as="li" variant="bodyM">
        {amenity}
      </Text>)}
  </ListItem>;
export const RoomAmenities = ({
  room
}: RoomAmenitiesPropsType) => {
  return <div>
      <Header>
        <Icon name="LightCeiling" size="md" colorPath="content.neutral.c600" />
        <Text variant="titleL">
          <FormattedMessageWrapper id="roomAmenities" defaultMessage="Room amenities" />
        </Text>
      </Header>
      <RoomAmenitiesList amenities={room.amenities} />
    </div>;
};
export const getTopRoomAmenities = (amenities: Room['amenities']) => {
  if (toggle('9f14db7f-room-amenities-improvements', true, false)) return [];
  return RANKED_AMENITIES.filter(amenity => amenities.includes(amenity.defaultMessage)).slice(0, 3);
};
export const RankedTopRoomAmenities = ({
  amenities
}: {
  amenities: Room['amenities'];
}) => {
  const rankedAmenities = getTopRoomAmenities(amenities);
  return <>
      {rankedAmenities.map((amenity, index) => <RoomInformationItemWrapper key={index} variant="bodyS" colorPath="content.neutral.c600" dataId="RoomAmenity">
          <StyledIcon name={amenity.icon} size="sm" colorPath="content.neutral.c600" />
          <FormattedMessageWrapper {...amenity} />
        </RoomInformationItemWrapper>)}
    </>;
};

require("./RoomAmenities.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./RoomAmenities.tsx");